import { render, staticRenderFns } from "./TipTapExtensionsMenu.vue?vue&type=template&id=4022bc2f&scoped=true"
import script from "./TipTapExtensionsMenu.vue?vue&type=script&lang=js"
export * from "./TipTapExtensionsMenu.vue?vue&type=script&lang=js"
import style0 from "./TipTapExtensionsMenu.vue?vue&type=style&index=0&id=4022bc2f&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4022bc2f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDivider,VIcon,VTooltip})
